import React, { FC, useCallback, useEffect, useState } from 'react'
import { Grid, Switch, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { createStyles, withStyles, makeStyles } from '@mui/styles'

interface IProps {
  disabled?: boolean
  label: string
  getTwoFactorAuth: (value: boolean) => void
  isChecked?: boolean
}
const useStyle = makeStyles((theme: Theme) => ({
  main: {
    width: 272,
  },
  switch: {
    opacity: ({ disabled }: IProps) => (disabled ? 0.6 : 1),
  },
  label: {
    opacity: 0.8,
    color: theme.palette.primary.light,
  },
}))

const AntSwitch = withStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 40,
      height: 24,
      padding: 0,
      display: 'flex',
    },
    switchBase: {
      padding: 3,
      color: theme.palette.primary.light,
      '&$checked': {
        transform: 'translateX(16px)',
        color: theme.palette.primary.light,
        '& + $track': {
          opacity: 1,
          backgroundColor: theme.palette.secondary.main,
          borderColor: theme.palette.secondary.main,
        },
      },
    },
    thumb: {
      width: 18,
      height: 18,
      boxShadow: 'none',
    },
    track: {
      borderRadius: 40 / 2,
      opacity: 0.6,
      backgroundColor: '#F1F3F5',
    },
    checked: {},
  }),
)(Switch)

export const InputSwitch: FC<IProps> = ({ disabled, label, getTwoFactorAuth, isChecked = false }) => {
  const classes = useStyle({ disabled, label, getTwoFactorAuth })
  const [checked, setChecked] = useState<boolean>(false)
  useEffect(() => {
    setChecked(!!isChecked)
  }, [isChecked])

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setChecked(event.target.checked)
      getTwoFactorAuth(event.target.checked)
    },
    [getTwoFactorAuth],
  )

  return (
    <Grid className={classes.main} container direction={'row'} justifyContent={'space-between'}>
      <Grid item>
        <Typography className={classes.label}>{label}</Typography>
      </Grid>
      <Grid item>
        <AntSwitch
          className={classes.switch}
          disabled={disabled}
          checked={checked}
          onChange={handleChange}
          name="checked"
        />
      </Grid>
    </Grid>
  )
}
